import * as React from 'react';
import { Image } from '@fluentui/react-components';
import WaffleSvg from '../../media/Waffle.svg';
import { useEventListener } from '../../modules/useEventListener';
import { MicrosoftCloudMenu } from './MicrosoftCloudMenu';

export function WaffleMenu() {
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const [showWaffleMenu, setShowWaffleMenu] = React.useState(false);

  function handleOutsideClick(event: MouseEvent) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      setShowWaffleMenu(false);
    }
  }

  useEventListener('mousedown', (e: MouseEvent) => handleOutsideClick(e));

  return (
    <div ref={wrapperRef}>
      <a href="#" role="button" onClick={() => setShowWaffleMenu(!showWaffleMenu)}>
        <Image src={WaffleSvg} alt="Waffle Menu" aria-label="Waffle Menu" />
      </a>
      {showWaffleMenu ? <MicrosoftCloudMenu /> : null}
    </div>
  );
}
